import React from "react";
import Orbit from "./designs/orbit/Orbit";

const App = () => <Orbit />;

export default App;
